// CREATE OBV
export const CREATE_OBV = 'CREATE_OBV';

// CREATE PLAID LINK
export const CREATE_PLAID_LINK = 'CREATE_PLAID_LINK';

// CREATE LINK EVENT
export const CREATE_LINK_EVENT = 'CREATE_LINK_EVENT';
export const CREATE_LINK_EVENT_FAILURE = 'CREATE_LINK_EVENT_FAILURE';

// OBV VERIFICATION
export const OBV_VERIFICATION = 'OBV_VERIFICATION';

export const CONTINUE_OAUTH_CALLBACK = 'CONTINUE_OAUTH_CALLBACK';

// EXIT EVENT
export const EXIT_EVENT = 'EXIT_EVENT';

// Confirm bank
export const CONFIRM_BANK = 'CONFIRM_BANK';

// BACK MERCHANT
export const BACK_MERCHANT = 'BACK_MERCHANT';

// UPDATE OBV INFO
export const UPDATE_OBV_INFO = 'UPDATE_OBV_INFO';

// PUSH ERROR MESSAGE
export const PUSH_ERROR_MESSAGE = 'PUSH_ERROR_MESSAGE';

// PUSH ERROR MESSAGE
export const CLEAR_ERROR_MESSAGE = 'PUSH_ERROR_MESSAGE';

export const ADD_PROPERTIES = "ADD_PROPERTIES";
